import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputAdornment,
  Tooltip,
  CircularProgress,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useThemeMediaQuery } from "@fuse/hooks";
import FusePageCarded from "@fuse/core/FusePageCarded";
import AddApplicationHeader from "../AddApplicationHeader";
import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/system";
import { toast } from "react-toastify";
import { lighten } from "@mui/material/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useGetApplicationDetailQuery, useAnalyzeImageMutation } from "@/store/services/applications";
import { useGetAddressesListQuery } from "@/store/services/address";
import { useParams } from "react-router-dom";
import FuseLoading from "@fuse/core/FuseLoading";
import ApplicationsStatus from "../../ApplicationsStatus";
import ImageViewer from "react-simple-image-viewer";
import "./style.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useGetAreasQuery } from "@/store/services/areas";
import { motion } from "motion/react";
import Link from "@fuse/core/Link";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  selectCurrentPreviewImage,
  setCurrentPreviewImage,
} from "@/components/theme-layouts/components/navbar/navbarSlice";
import ImageAIDialog from "./ImageAIDialog";
import {
  Control,
  FieldErrors,
  UseFormWatch,
  UseFormSetValue,
} from "react-hook-form";
import { Area } from "@/store/services/areas";
import { ApplicationObjcet } from "@/store/services/applications";
import heic2any from "heic2any";

const TODAY_DATE = new Date().toISOString().split("T")[0];

interface LineItemFormData {
  area: string;
  name: string;
  condition: string;
  model: string;
  purchased_date: string;
  purchased_cost: number | null;
  current_cost: number | null;
  description: string;
  images: (File | string | { product_image: string })[];
  area_image?: File | string | { product_image: string };
  quantity?: number;
  other_area?: string;
  other_line_item_name?: string;
  parentIndex?: number;
}

interface AddApplicationProps {
  // NOTE: Several pages pass `Record<number, ...>` into this component.
  // We keep the internal `LineItemFormData[]` structure, but accept `any` at the boundary
  // to avoid leaking strict types across pages.
  lineItems: any;
  setLineItems: React.Dispatch<React.SetStateAction<any>>;
  isView?: boolean;
  deletedId?: number[];
  setDeletedId?: React.Dispatch<React.SetStateAction<number[]>>;
  addressId?: number;
  selectedAddress?: {
    id: number;
    name: string | null;
    location_name: string | null;
    type: string | null;
    documents?: Array<{
      id: number;
      address_id: number;
      file_name: string;
      file_type: string;
      document_file_url: string;
    }>;
  };
  onRequestChangeAddress?: () => void;
}

interface PreAnalyzedData {
  choices: {
    message: {
      content: string;
    };
  }[];
}

interface LineItemProps {
  index: number;
  displayIndex: number;
  control: Control<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  onRemove: (index: number) => void;
  isRemovable: boolean;
  setValue: UseFormSetValue<any>;
  areas: { data: Area[] };
  isView?: boolean;
  applicationId?: string;
  expanded: boolean;
  isChildRemovable?: (childIndex: number) => boolean;
  onChange: () => void;
  selectedAreas?: Set<string>;
  childItems?: { item: LineItemFormData; index: number }[];
  expandedPanel?: Record<string, boolean>;
  setExpandedPanel?: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  removeLineItem?: (index: number, id?: number) => void;
  applicationData?: any;
  isLastChild?: boolean;
  parentItemIndex?: number;
  trigger?: (name?: any) => Promise<boolean>;
  setIsRemoveDialogOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setPendingRemove?: React.Dispatch<
    React.SetStateAction<{
      index: number;
      itemId?: number;
      isParent: boolean;
      areaName?: string;
    } | null>
  >;
}

const inputStyle = {
  "& .MuiInputBase-input": {
    lineHeight: 1.5,
  },
  "& .MuiInputBase-inputMultiline": {
    padding: 0,
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#6d7175",
    opacity: 1,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.6)",
  },
};

const selectStyle = {
  "& .MuiSelect-select.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.87)",
    WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.6)",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "& .MuiSvgIcon-root": {
    color: "rgba(0, 0, 0, 0.54)",
  },
};

// Removed AreaLineItemManager - using flat list with inline add button

function LineItem({
  index,
  displayIndex,
  control,
  errors,
  watch,
  onRemove,
  isRemovable,
  setValue,
  areas,
  isView,
  applicationId,
  expanded,
  isChildRemovable,
  onChange,
  selectedAreas = new Set(),
  childItems = [],
  expandedPanel,
  setExpandedPanel,
  removeLineItem,
  applicationData,
  isLastChild = false,
  parentItemIndex,
  trigger,
  setIsRemoveDialogOpen,
  setPendingRemove,
}: LineItemProps) {
	const currentPreviewImage = useAppSelector(selectCurrentPreviewImage);
	const dispatch = useAppDispatch();
	const [analyzeImage] = useAnalyzeImageMutation();
	const [isAIDialogOpen, setIsAIDialogOpen] = useState(false);
	const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [preAnalyzedData, setPreAnalyzedData] =
    useState<PreAnalyzedData | null>(null);
  const [isAreaChangeDialogOpen, setIsAreaChangeDialogOpen] = useState(false);
  const [pendingAreaChange, setPendingAreaChange] = useState<{
    newArea: string;
    currentArea: string;
  } | null>(null);
  const [fileSizeError, setFileSizeError] = useState<string | null>(null);
  const itemPrefix = `lineItems.${index}`;
  const selectedArea = useWatch({
    control: control as any,
    name: `${itemPrefix}.area`,
  });

  const selectedItem = useWatch({
    control: control as any,
    name: `${itemPrefix}.name`,
  });

  const otherArea = useWatch({
    control: control as any,
    name: `${itemPrefix}.other_area`,
  });

  const otherItem = useWatch({
    control: control as any,
    name: `${itemPrefix}.other_line_item_name`,
  });

  const images = useWatch({
    control: control as any,
    name: `${itemPrefix}.images`,
  });

  const model = useWatch({
    control: control as any,
    name: `${itemPrefix}.model`,
  });

  const description = useWatch({
    control: control as any,
    name: `${itemPrefix}.description`,
  });

  const isFileInputEnabled = () => {
    return true;
  };

  // Determine if this item is a child of another (used to hide area select and indent)
  const parentIndex = useWatch({
    control: control as any,
    name: `${itemPrefix}.parentIndex`,
  });
  const isChild = typeof parentIndex === "number";

  // Handle area change confirmation
  const handleAreaChangeConfirm = () => {
    if (!pendingAreaChange) return;

    const { newArea, currentArea } = pendingAreaChange;
    const currentItems = watch("lineItems") || [];

    // Create a new array without the child items of the current parent
    const newLineItems: any[] = [];
    const parentIndexMap: Record<number, number> = {}; // Maps old parent indices to new parent indices

    currentItems.forEach((item, itemIndex) => {
      if (typeof item.parentIndex === "undefined") {
        // This is a parent item
        const newParentIndex = newLineItems.length;
        parentIndexMap[itemIndex] = newParentIndex;

        if (itemIndex === index) {
          // Update the current parent item with the new area
          newLineItems.push({
            ...item,
            area: newArea,
            name: "",
            other_area: newArea === "Other" ? "" : item.other_area,
          });
        } else {
          // Keep other parent items as they are
          newLineItems.push(item);
        }
      } else if (item.parentIndex !== index) {
        // This is a child item of a different parent - keep it
        newLineItems.push(item);
      }
      // Skip child items of the current parent (they will be removed)
    });

    // Update parentIndex values for all child items
    newLineItems.forEach((item, itemIndex) => {
      if (typeof item.parentIndex === "number") {
        const newParentIndex = parentIndexMap[item.parentIndex];
        if (newParentIndex !== undefined) {
          item.parentIndex = newParentIndex;
        }
      }
    });

    // Add new child item for the new area
    const newChildItem = {
      area: newArea,
      name: "",
      images: [],
      area_image: undefined,
      quantity: 1,
      condition: "Old",
      purchased_date: "",
      purchased_cost: null,
      current_cost: null,
      model: "",
      other_area: "",
      other_line_item_name: "",
      description: "",
      parentIndex: parentIndexMap[index], // Use the new parent index
    };

    // Add the new child item
    newLineItems.push(newChildItem);

    // Clear the item selection in the form
    setValue(`${itemPrefix}.name`, "");

    // If changing to "Other" area, clear the other_area field
    if (newArea === "Other") {
      setValue(`${itemPrefix}.other_area`, "");
      // Trigger validation for the other_area field
      trigger?.(`${itemPrefix}.other_area`);
    }

    setValue("lineItems", newLineItems as any);

    // Close all other child items and open the new child item
    setExpandedPanel((prev) => {
      const newState: Record<number, boolean> = {};

      // Close all child accordions and preserve parent accordion states
      Object.keys(prev).forEach((key) => {
        const itemIndex = parseInt(key);
        const currentItems = watch("lineItems") || [];
        const item = currentItems[itemIndex];

        if (item && typeof item.parentIndex === "number") {
          // This is a child item - close it
          newState[itemIndex] = false;
        } else if (item && typeof item.parentIndex === "undefined") {
          // This is a parent item - preserve its state
          newState[itemIndex] = prev[itemIndex];
        }
      });

      // Open the new child item (it's at the end of the array)
      newState[newLineItems.length - 1] = true;
      return newState;
    });

    // Close dialog
    setIsAreaChangeDialogOpen(false);
    setPendingAreaChange(null);
  };

  const handleAreaChangeCancel = () => {
    setIsAreaChangeDialogOpen(false);
    setPendingAreaChange(null);
  };

  return (
    <Accordion 
      expanded={expanded} 
      onChange={onChange}
      sx={{
        '& .MuiAccordionSummary-root': {
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent !important',
          },
          '&:hover': {
            backgroundColor: 'transparent !important',
          },
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: !!errors.lineItems?.[index]?.name
                ? `${expanded ? "-22px" : "22px"}`
                : "0px",
            }}
            className="md:gap-1"
          >
            <ArrowDropDownIcon />
            {!isView && isRemovable && (
              <Tooltip title={isChild ? "Remove Item" : "Remove Area"}>
                <IconButton
                  type="button"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    // Show confirmation dialog instead of directly removing
                    const currentLineItems = watch("lineItems") || [];
                    const itemToRemove = currentLineItems[index];
                    const isParent =
                      typeof itemToRemove.parentIndex === "undefined";
                    setPendingRemove?.({
                      index,
                      itemId: undefined, // Will be set by the parent component if needed
                      isParent,
                      areaName: itemToRemove.area,
                    });
                    setIsRemoveDialogOpen?.(true);
                  }}
                  sx={{
                    backgroundColor: "rgba(211, 47, 47, 0.1)",
                    "&:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.2)",
                    },
                  }}
                  className="w-5 h-5 md:w-7 md:h-7"
                >
                  <CloseIcon className="w-3 h-3 md:w-5 md:h-5" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        }
        aria-controls={`panel-${index}-content`}
        id={`panel-${index}-header`}
        sx={{
          magin: 0,
        }}
      >
        <Box className="flex justify-between w-full mr-1.5">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 2,
              width: "100%",
              marginRight: 1,
            }}
          >
            {/* Select Area Dropdown - Only for parent items */}
            {!isChild && (
              <div className="w-full">
                <div className="flex flex-col sm:flex-row gap-2 w-full">
                  <div className="w-full sm:w-[40%] md:w-[25%] min-w-0">
                    <Controller
                      name={`${itemPrefix}.area`}
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          size="small"
                          sx={{ opacity: !areas?.data?.length ? "0.5" : "1" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <InputLabel id={`area-select-${index}`}>
                            Select Area *
                          </InputLabel>
                          <Select
                            labelId={`area-select-${index}`}
                            label="Select Area *"
                            value={field.value || ""}
                            onChange={(e) => {
                              const newArea = e.target.value as string;
                              const currentArea = field.value || "";

                              // Check if this area already has child items
                              const currentItems = watch("lineItems") || [];
                              const hasChildItems = currentItems.some(
                                (item) =>
                                  typeof item.parentIndex === "number" &&
                                  item.parentIndex === index
                              );

                              // If changing from one area to another AND this area has child items, show confirmation dialog
                              if (
                                currentArea &&
                                newArea &&
                                currentArea !== newArea &&
                                hasChildItems &&
                                !isView
                              ) {
                                setPendingAreaChange({
                                  newArea,
                                  currentArea,
                                });
                                setIsAreaChangeDialogOpen(true);
                                return; // Don't change the field value yet
                              }

                              // If selecting area for the first time, set area on parent and add a child item
                              field.onChange(e);
                              // Only add a child item when area is selected if no item exists in that area
                              if (e.target.value && !isView) {
                                const currentItems = watch("lineItems") || [];
                                const selectedArea = e.target.value as string;

                                // Clear the item selection when area changes
                                setValue(`${itemPrefix}.name`, "");

                                // If changing to "Other" area, clear the other_area field
                                if (selectedArea === "Other") {
                                  setValue(`${itemPrefix}.other_area`, "");
                                  // Trigger validation for the other_area field
                                  trigger?.(`${itemPrefix}.other_area`);
                                }

                                const newChildItem = {
                                  area: selectedArea,
                                  name: "",
                                  images: [],
                                  area_image: undefined,
                                  quantity: 1,
                                  condition: "Old",
                                  purchased_date: "",
                                  purchased_cost: null,
                                  current_cost: null,
                                  model: "",
                                  other_area: "",
                                  other_line_item_name: "",
                                  description: "",
                                  parentIndex: index,
                                };
                                const newLineItems = [
                                  ...currentItems,
                                  newChildItem,
                                ];
                                setValue("lineItems", newLineItems as any);
                                // Close only other child items and expand the new child item
                                setExpandedPanel((prev) => {
                                  const newState: Record<number, boolean> = {
                                    ...prev,
                                  };

                                  // Close all child accordions (items with parentIndex)
                                  Object.keys(newState).forEach((key) => {
                                    const itemIndex = parseInt(key);
                                    const currentItems =
                                      watch("lineItems") || [];
                                    const item = currentItems[itemIndex];
                                    if (
                                      item &&
                                      typeof item.parentIndex === "number"
                                    ) {
                                      newState[itemIndex] = false;
                                    }
                                  });

                                  // Open the new child item
                                  newState[currentItems.length] = true;
                                  return newState;
                                });
                              }
                            }}
                            error={!!errors.lineItems?.[index]?.area}
                            disabled={isView || !areas?.data?.length}
                            sx={selectStyle}
                            IconComponent={
                              !areas?.data?.length
                                ? () => (
                                    <CircularProgress
                                      size={20}
                                      sx={{
                                        marginRight: 1.5,
                                        color: "action.active",
                                      }}
                                    />
                                  )
                                : undefined
                            }
                          >
                            <MenuItem value="" disabled>
                              {!areas?.data?.length
                                ? "Loading areas..."
                                : "Select Area *"}
                            </MenuItem>
                            {areas?.data?.map((a) => {
                              // Check if this area is selected in OTHER dropdowns (not the current one)
                              const currentItems = watch("lineItems") || [];
                              const isSelectedInOtherDropdowns =
                                currentItems.some(
                                  (item, idx) =>
                                    idx !== index && // Not the current dropdown
                                    typeof item.parentIndex === "undefined" && // It's a parent item (area)
                                    item.area === a.name // This area is selected
                                );

                              return (
                                <MenuItem
                                  key={a.id}
                                  value={a.name}
                                  disabled={isSelectedInOtherDropdowns}
                                  title={
                                    isSelectedInOtherDropdowns ? "Selected" : ""
                                  }
                                >
                                  {a.name}{" "}
                                  {isSelectedInOtherDropdowns
                                    ? "(selected)"
                                    : ""}
                                </MenuItem>
                              );
                            })}
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                          {errors.lineItems?.[index]?.area && (
                            <FormHelperText error>
                              {errors.lineItems[index].area.message as string}
                            </FormHelperText>
                          )}
                        </FormControl>
                      )}
                    />
                  </div>
                  {/* Other Area Field - Show in same row when "Other" is selected */}
                  {(selectedArea as string) === "Other" && (
                    <div className="md:w-[25%] min-w-0">
                      <Controller
                        name={`${itemPrefix}.other_area`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            size="small"
                            type="text"
                            required
                            label="Other Area"
                            error={!!errors.lineItems?.[index]?.other_area}
                            disabled={isView}
                            helperText={
                              errors?.lineItems?.[index]?.other_area
                                ?.message as string
                            }
                            sx={inputStyle}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                              field.onChange(e);
                              // Trigger validation for this field
                              trigger?.(`${itemPrefix}.other_area`);
                            }}
                          />
                        )}
                      />
                    </div>
                  )}
                  {selectedArea && (
                  <div>
                    <Controller
                      name={`${itemPrefix}.area_image`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <>
                          {!isView && (
                            <div className="flex items-center flex-wrap gap-2">
                              <p className=" text-gray-500 text-sm">Upload Area Image:</p>
                              <div className="flex flex-wrap items-center gap-1 md:gap-3">
                                <div>
                                  <Tooltip title="Upload area image">
                                    <Box
                                      sx={(theme) => ({
                                        backgroundColor: lighten(
                                          theme.palette.background.default,
                                          0.02
                                        ),
                                        ...theme.applyStyles("light", {
                                          backgroundColor: lighten(
                                            theme.palette.background.default,
                                            0.2
                                          ),
                                        }),
                                        border: "2px dashed #ccc",
                                      })}
                                      component="label"
                                      htmlFor={`area-image-file-${index}`}
                                      className="productImageUpload flex items-center justify-center relative w-12 sm:w-16 h-8 rounded-lg overflow-hidden shadow-sm cursor-pointer hover:shadow-lg"
                                    >
                                      <input
                                        title="Upload area image"
                                        placeholder="Upload area image"
                                        accept="image/*"
                                        className="hidden"
                                        id={`area-image-file-${index}`}
                                        disabled={isView}
                                        type="file"
                                        onChange={(e) => {
                                          const file = e.target.files?.[0];
                                          if (file) {
                                            // Check for image formats
                                            const validImageTypes = [
                                              "image/jpeg",
                                              "image/png",
                                              "image/gif",
                                              "image/webp",
                                              "image/heic",
                                              "image/heif",
                                              "image/raw",
                                              "image/x-raw",
                                              "image/svg",
                                              "image/svg+xml",
                                              "image/bmp",
                                              "image/tiff",
                                            ];

                                            const isHEIC =
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".heic") ||
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".heif");

                                            if (
                                              !validImageTypes.some((type) =>
                                                file.type.startsWith(type)
                                              ) &&
                                              !isHEIC
                                            ) {
                                              toast.error(
                                                `${file.name} is not a supported image format.`
                                              );
                                              return;
                                            }

                                            if (file.size > 5 * 1024 * 1024) {
                                              setFileSizeError(`${file.name} is larger than 5MB. Please select a smaller image.`);
                                              return;
                                            }

                                            // Clear any previous error
                                            setFileSizeError(null);

                                            // Convert HEIC/HEIF files to JPEG for preview
                                            if (isHEIC) {
                                              heic2any({
                                                blob: file,
                                                toType: "image/jpeg",
                                                quality: 0.8,
                                              })
                                                .then((convertedBlob) => {
                                                  const convertedFile =
                                                    new File(
                                                      [convertedBlob as Blob],
                                                      file.name.replace(
                                                        /\.(heic|heif)$/i,
                                                        ".jpg"
                                                      ),
                                                      {
                                                        type: "image/jpeg",
                                                      }
                                                    );
                                                  setFileSizeError(null);
                                                  onChange(convertedFile);
                                                  // Reset file input to allow re-uploading the same file
                                                  e.target.value = '';
                                                })
                                                .catch((error) => {
                                                  console.error(
                                                    "Error converting HEIC file:",
                                                    error
                                                  );
                                                  toast.error(
                                                    `Failed to convert ${file.name}. Please try a different image.`
                                                  );
                                                  // Reset file input even on error
                                                  e.target.value = '';
                                                });
                                            } else {
                                              setFileSizeError(null);
                                              onChange(file);
                                              // Reset file input to allow re-uploading the same file
                                              e.target.value = '';
                                            }
                                          }
                                        }}
                                      />
                                      <FuseSvgIcon size={20} color="action">
                                        heroicons-outline:arrow-up-on-square
                                      </FuseSvgIcon>
                                    </Box>
                                  </Tooltip>
                                </div>

                                {/* Preview area image */}
                                {value && (
                                  <Box
                                    position="relative"
                                    className="cursor-pointer rounded-lg border-1 border-gray-300 hover:shadow-lg"
                                  >
                                    <img
                                      src={
                                        typeof value === "string"
                                          ? value
                                          : value instanceof File
                                            ? URL.createObjectURL(value)
                                            : value?.product_image || ""
                                      }
                                      alt="Area image"
                                      onClick={() => {
                                        dispatch(setCurrentPreviewImage(0));
                                      }}
                                      className="object-cover sm:w-[50px] w-[35px] h-8 rounded-md"
                                    />
                                    {!isView && (
                                      <Box
                                        position="absolute"
                                        top={-4}
                                        right={-6}
                                        bgcolor="rgba(0,0,0,0.6)"
                                        color="#fff"
                                        width={16}
                                        height={16}
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        borderRadius="50%"
                                        fontSize={12}
                                        sx={{
                                          cursor: "pointer",
                                          zIndex: 1,
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          onChange(null);
                                        }}
                                      >
                                        ×
                                      </Box>
                                    )}
                                    {currentPreviewImage !== null && (
                                      <ImageViewer
                                        src={[
                                          typeof value === "string"
                                            ? value
                                            : value instanceof File
                                              ? URL.createObjectURL(value)
                                              : value?.product_image || ""
                                        ]}
                                        currentIndex={currentPreviewImage}
                                        disableScroll={false}
                                        closeOnClickOutside={true}
                                        onClose={() => {
                                          dispatch(setCurrentPreviewImage(null));
                                        }}
                                      />
                                    )}
                                  </Box>
                                )}
                              </div>
                            </div>
                          )}

                          {/* View mode area image */}
                          {isView && value && (
                            <div className="flex gap-2 items-center">
                              <p className="text-gray-500 text-sm">
                                Area Image:
                              </p>
                              <Box
                                display="flex"
                                gap={2}
                                flexWrap="wrap"
                              >
                                <Box
                                  position="relative"
                                  className="cursor-pointer rounded-lg border-1 border-gray-300 hover:shadow-lg"
                                >
                                  <img
                                    src={
                                      typeof value === "string"
                                        ? value
                                        : value instanceof File
                                          ? URL.createObjectURL(value)
                                          : value?.product_image || ""
                                    }
                                    alt="Area image"
                                    onClick={() => {
                                      dispatch(setCurrentPreviewImage(0));
                                    }}
                                    // style={{
                                    //   width: 60,
                                    //   height: 60,
                                    //   objectFit: "cover",
                                    //   borderRadius: "inherit",
                                    // }}
                                    className="object-cover sm:w-[50px] w-[35px] h-8 rounded-md"
                                  />
                                  {currentPreviewImage !== null && (
                                    <ImageViewer
                                      src={[
                                        typeof value === "string"
                                          ? value
                                          : value instanceof File
                                            ? URL.createObjectURL(value)
                                            : value?.product_image || ""
                                      ]}
                                      currentIndex={currentPreviewImage}
                                      disableScroll={false}
                                      closeOnClickOutside={true}
                                      onClose={() => {
                                        dispatch(setCurrentPreviewImage(null));
                                      }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>
                )}
                </div>

                {/* File Size Error Message */}
                {fileSizeError && (
                  <div className="w-full mt-2">
                    <Typography variant="body2" color="error" className="text-sm">
                      {fileSizeError}
                    </Typography>
                  </div>
                )}

                {/* Area Image Upload - Only for parent items */}
                
              </div>
            )}

            {/* Item Number Display - Only for child items */}
            {isChild && (
              <div className="w-full">
                <Typography variant="h6" className="text-lg font-semibold text-gray-700">
                  Item #{(() => {
                    // Calculate the correct item number within the current area
                    const currentItems = watch("lineItems") || [];
                    const currentItem = currentItems[index];
                    
                    if (!currentItem || typeof currentItem.parentIndex !== "number") {
                      return 1;
                    }
                    
                    const parentIndex = currentItem.parentIndex;
                    const parentItem = currentItems[parentIndex];
                    
                    if (!parentItem) {
                      return 1;
                    }
                    
                    // Count child items that belong to the same parent (same area)
                    let itemCount = 0;
                    for (let i = 0; i <= index; i++) {
                      const item = currentItems[i];
                      if (item && typeof item.parentIndex === "number" && item.parentIndex === parentIndex) {
                        itemCount++;
                        if (i === index) {
                          return itemCount;
                        }
                      }
                    }
                    
                    return 1;
                  })()}
                </Typography>
              </div>
            )}
          </Box>
          {!(!isView && (selectedArea as string) && isChild && isLastChild) && (
            <div className="md:w-[120px]"></div>
          )}
          {!isView && (selectedArea as string) && isChild && isLastChild && (
            <Button
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                // Validate current item before adding new one using form validation
                const fieldsToValidate = [
                  `lineItems.${index}.name`,
                  `lineItems.${index}.images`,
                ];
                // If user selected "Other", also validate the Other Item field
                if ((selectedItem as string) === "Other") {
                  fieldsToValidate.push(
                    `lineItems.${index}.other_line_item_name`
                  );
                }

                const isValid = await trigger?.(fieldsToValidate);

                if (!isValid) {
                  // Validation errors will be shown in the input fields
                  // Open the current accordion to show validation errors
                  setExpandedPanel?.((prev) => {
                    const newState: Record<number, boolean> = { ...prev };
                    newState[index] = true;
                    return newState;
                  });

                  // Check if we're on a small screen (below md) and if there are validation errors on images
                  const isMobileScreen = window.innerWidth < 768; // md breakpoint is 768px
                  const currentErrors = errors.lineItems?.[index];

                  if (isMobileScreen && currentErrors?.images) {
                    // Scroll to the upload images section after a short delay to allow accordion to open
                    setTimeout(() => {
                      const uploadSection = document.getElementById(
                        `upload-images-${index}`
                      );
                      if (uploadSection) {
                        uploadSection.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                        });
                      }
                    }, 50);
                  }

                  return;
                }

                const current = (watch("lineItems") as any) || [];
                const newItem = {
                  area: selectedArea as string,
                  name: "",
                  condition: "Old",
                  model: "",
                  purchased_date: "",
                  purchased_cost: null,
                  current_cost: null,
                  description: "",
                  images: [],
                  area_image: undefined,
                  quantity: 1,
                  other_area: "",
                  other_line_item_name: "",
                  parentIndex: parentItemIndex,
                };
                const newLineItems = [...current, newItem];
                const newIndex = newLineItems.length - 1;
                setValue("lineItems", newLineItems as LineItemFormData[]);
                // Close only other child items and open the newly added item
                setExpandedPanel?.((prev) => {
                  const newState: Record<number, boolean> = {
                    ...prev,
                  };

                  // Close all child accordions (items with parentIndex)
                  Object.keys(newState).forEach((key) => {
                    const itemIndex = parseInt(key);
                    const currentItems = watch("lineItems") || [];
                    const item = currentItems[itemIndex];
                    if (item && typeof item.parentIndex === "number") {
                      newState[itemIndex] = false;
                    }
                  });

                  // Open the newly added item
                  newState[newIndex] = true;
                  return newState;
                });
              }}
              startIcon={window.innerWidth > 768 ? <AddIcon /> : null}
              variant="contained"
              color="primary"
              className={`whitespace-nowrap -mt-0.5 text-xs md:text-base`}
              sx={{
                minWidth: { xs: "70px", sm: "80px" },
                height: { xs: "28px", sm: "32px" },
              }}
            >
              Add Item
            </Button>
          )}
        </Box>
      </AccordionSummary>
      {(!isChild ? childItems.length > 0 : true) && (
        <AccordionDetails>
          <div
            className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4`}
          >
            {/* Only show other form fields when an area is selected AND this is a child item */}
            {selectedArea && isChild && (
              <>
                <div className="w-full col-span-6">
                  <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 lg:gap-4">
                    {/* Upload Section - First Column */}
                    <div
                      id={`upload-images-${index}`}
                      className="space-y-3 w-full lg:w-auto"
                      style={{ marginTop: "-10px" }}
                    >
                      <Controller
                        name={`${itemPrefix}.images`}
                        control={control}
                        render={({ field: { onChange, value = [] } }) => (
                          <>
                            {!isView && (
                              <div>
                                <p className="mb-2 text-gray-500 text-sm">
                                  {value?.length
                                    ? "Upload Image"
                                    : "Upload Image"}
                                </p>
                                <div
                                  className={`flex flex-wrap items-center gap-1 md:gap-3`}
                                >
                                  <div>
                                    <Tooltip
                                      title={
                                        value.length >= 1
                                          ? "Max limit reached!"
                                          : "You can only upload 1 image."
                                      }
                                    >
                                      <Box
                                        sx={(theme) => ({
                                          backgroundColor: lighten(
                                            theme.palette.background.default,
                                            0.02
                                          ),
                                          ...theme.applyStyles("light", {
                                            backgroundColor: lighten(
                                              theme.palette.background.default,
                                              0.2
                                            ),
                                          }),
                                          opacity:
                                            !isFileInputEnabled() ||
                                            value.length >= 1
                                              ? "0.35"
                                              : "1",
                                          border: "2px dashed #ccc",
                                        })}
                                        component="label"
                                        htmlFor={`button-file-${index}`}
                                        className={`productImageUpload flex items-center justify-center relative w-20 h-16 sm:w-24 sm:h-20 rounded-lg overflow-hidden shadow-sm ${
                                          isView ||
                                          !isFileInputEnabled() ||
                                          value.length >= 1
                                            ? "cursor-not-allowed border-2"
                                            : "cursor-pointer hover:shadow-lg"
                                        }`}
                                      >
                                        <input
                                          title="Upload image"
                                          placeholder="Upload image"
                                          accept="image/*"
                                          className="hidden"
                                          id={`button-file-${index}`}
                                          disabled={
                                            isView ||
                                            !isFileInputEnabled() ||
                                            value.length >= 1
                                          }
                                          type="file"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (!file) return;

                                            // Check for image formats including iPhone formats
                                            const validImageTypes = [
                                              "image/jpeg",
                                              "image/png",
                                              "image/gif",
                                              "image/webp",
                                              "image/heic",
                                              "image/heif",
                                              "image/raw",
                                              "image/x-raw",
                                              "image/svg",
                                              "image/svg+xml",
                                              "image/bmp",
                                              "image/tiff",
                                            ];

                                            // Check if file type is in valid types or if it's a HEIC file by extension
                                            const isHEIC =
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".heic") ||
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".heif");

                                            if (
                                              !validImageTypes.some((type) =>
                                                file.type.startsWith(type)
                                              ) &&
                                              !isHEIC
                                            ) {
                                              toast.error(
                                                `${file.name} is not a supported image format.`
                                              );
                                              return;
                                            }

                                           

                                            // Convert HEIC/HEIF files to JPEG for preview
                                            if (isHEIC) {
                                              heic2any({
                                                blob: file,
                                                toType: "image/jpeg",
                                                quality: 0.8,
                                              })
                                                .then((convertedBlob) => {
                                                  const convertedFile =
                                                    new File(
                                                      [convertedBlob as Blob],
                                                      file.name.replace(
                                                        /\.(heic|heif)$/i,
                                                        ".jpg"
                                                      ),
                                                      {
                                                        type: "image/jpeg",
                                                      }
                                                    );
                                                  setFileSizeError(null);
                                                  onChange([convertedFile]);
                                                  // Reset file input to allow re-uploading the same file
                                                  e.target.value = '';
                                                })
                                                .catch((error) => {
                                                  console.error(
                                                    "Error converting HEIC file:",
                                                    error
                                                  );
                                                  toast.error(
                                                    `Failed to convert ${file.name}. Please try a different image.`
                                                  );
                                                  // Reset file input even on error
                                                  e.target.value = '';
                                                });
                                            } else {
                                              setFileSizeError(null);
                                              onChange([file]);
                                              // Reset file input to allow re-uploading the same file
                                              e.target.value = '';
                                            }
                                          }}
                                        />
                                        {isView}
                                        <FuseSvgIcon size={24} color="action">
                                          heroicons-outline:arrow-up-on-square
                                        </FuseSvgIcon>
                                      </Box>
                                    </Tooltip>
                                    <p className="text-xs text-gray-500 mt-1">
                                      (Upload 1 image only)
                                    </p>
                                    {/* Image validation error */}
                                    {errors.lineItems?.[index]?.images && (
                                      <div className="w-full mb-2">
                                        {Array.isArray(
                                          errors.lineItems[index].images
                                        ) ? (
                                          errors.lineItems[index].images.map(
                                            (
                                              error: any,
                                              errorIndex: number
                                            ) => (
                                              <FormHelperText
                                                key={errorIndex}
                                                error
                                              >
                                                {error?.message}
                                              </FormHelperText>
                                            )
                                          )
                                        ) : (
                                          <FormHelperText error>
                                            {
                                              errors.lineItems[index].images
                                                .message as string
                                            }
                                          </FormHelperText>
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  {/* Preview thumbnails in same row */}
                                  <div className="flex gap-2 md:flex-wrap">
                                    {((value as any) || []).map(
                                      (file: any, i: number) => {
                                        const imageSrc =
                                          typeof file === "string"
                                            ? file
                                            : file instanceof File
                                              ? URL.createObjectURL(file)
                                              : file?.product_image || "";
                                        // Create a unique key that includes file info to force re-render
                                        const uniqueKey = typeof file === "string" 
                                          ? `${file}-${i}` 
                                          : file instanceof File 
                                            ? `${file.name}-${file.size}-${file.lastModified}-${i}`
                                            : `${file?.product_image || 'unknown'}-${i}`;
                                        return (
                                          <Box
                                            key={uniqueKey}
                                            position="relative"
                                            className="cursor-pointer rounded-lg border-1 border-gray-300 hover:shadow-lg"
                                          >
                                            <img
                                              src={imageSrc}
                                              alt={`Uploaded ${i}`}
                                              onClick={() => {
                                                dispatch(
                                                  setCurrentPreviewImage(i)
                                                );
                                              }}
                                              // style={{
                                              //   width: 50,
                                              //   height: 50,
                                              //   objectFit: "cover",
                                              //   borderRadius: "inherit",
                                              // }}
                                              className="object-cover sm:w-[50px] w-[35px] sm:h-[60px] h-[35px]"
                                            />
                                            {!isView && (
                                              <Box
                                                position="absolute"
                                                top={-4}
                                                right={-6}
                                                bgcolor="rgba(0,0,0,0.6)"
                                                color="#fff"
                                                width={16}
                                                height={16}
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                borderRadius="50%"
                                                fontSize={12}
                                                sx={{
                                                  cursor: "pointer",
                                                  zIndex: 1,
                                                }}
                                                onClick={() => {
                                                  const updatedImages = [
                                                    ...(value as any),
                                                  ];
                                                  updatedImages.splice(i, 1);
                                                  onChange(updatedImages);
                                                }}
                                              >
                                                ×
                                              </Box>
                                            )}
                                            {currentPreviewImage !== null && (
                                              <ImageViewer
                                                src={
                                                  (value as any)?.map(
                                                    (file: any) => {
                                                      if (
                                                        typeof file === "string"
                                                      ) {
                                                        return file;
                                                      }
                                                      if (file?.product_image) {
                                                        return file.product_image;
                                                      }
                                                      if (
                                                        file instanceof File
                                                      ) {
                                                        return URL.createObjectURL(
                                                          file
                                                        );
                                                      }
                                                      return "";
                                                    }
                                                  ) || []
                                                }
                                                currentIndex={
                                                  currentPreviewImage
                                                }
                                                disableScroll={false}
                                                closeOnClickOutside={true}
                                                onClose={() => {
                                                  dispatch(
                                                    setCurrentPreviewImage(null)
                                                  );
                                                }}
                                              />
                                            )}
                                          </Box>
                                        );
                                      }
                                    )}
                                  </div>

                                  {/* Analyze with AI Button - In same row */}
                                  <div className="hidden lg:flex flex-col lg:items-center w-full lg:w-auto mt-1 md:mt-0">
                                    <Button
                                      type="button"
                                      variant="contained"
                                      color="secondary"
                                      size="small"
                                      id="image-ai-button"
                                      onClick={async () => {
                                          if (preAnalyzedData) {
                                            setIsAIDialogOpen(true);
                                            return;
                                          }

                                          setIsAnalyzing(true);
                                          try {
                                            if (!(images as any)?.length) {
                                              toast.error("Please upload an image to analyze");
                                              return;
                                            }

                                            // Get the first image and build FormData (image + modelNumber + description + selected item)
                                            const image = (images as any)[0];
                                            const formData = new FormData();
                                            if (image instanceof File) {
                                              formData.append('image', image);
                                            } else if (typeof image === 'string') {
                                              const response = await fetch(image);
                                              const blob = await response.blob();
                                              const file = new File([blob], 'image.jpg', { type: blob.type });
                                              formData.append('image', file);
                                            } else if (image?.product_image) {
                                              // Update case: send image URL for server to fetch (avoids CORS from client-side fetch)
                                              formData.append('image_url', image.product_image);
                                            }
                                            if (model != null) formData.append('modelNumber', model as string);
                                            if (description != null) formData.append('description', description as string);
                                            // Send only the selected line item, not the whole array
                                            const itemToSend = selectedItem || 'Other';
                                            formData.append('items[]', itemToSend);

                                            // analyzeImage API handles image upload + analysis, returns analysis result
                                            const uploadResponse = await analyzeImage(formData).unwrap();
                                            const analysis =
                                              uploadResponse?.data?.analysis ||
                                              uploadResponse?.analysis ||
                                              uploadResponse;

                                            if (analysis?.choices?.[0]?.message?.content) {
                                              setPreAnalyzedData(analysis);
                                              setIsAIDialogOpen(true);
                                            } else {
                                              toast.error(
                                                uploadResponse?.error || "Failed to analyze"
                                              );
                                            }
                                          } catch (error) {
                                            console.error("Error in AI analysis:", error);
                                            toast.error("Failed to analyze");
                                          } finally {
                                            setIsAnalyzing(false);
                                          }
                                        }}
                                      disabled={
                                        !(images as any)?.length || isAnalyzing
                                      }
                                    >
                                      {isAnalyzing ? (
                                        <>
                                          <CircularProgress
                                            size={16}
                                            sx={{ mr: 1 }}
                                          />
                                          Analyzing...
                                        </>
                                      ) : (
                                        "Analyze with AI"
                                      )}
                                    </Button>
                                    <Typography
                                      color="text.secondary"
                                      className="mt-1 text-xs text-center"
                                    >
                                      {isAnalyzing
                                          ? "Analyzing..."
                                          : "Upload image to analyze"}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* View mode images */}
                            <div>
                              {(isView && value?.length > 0) && (
                                <div>
                                  <p className="mb-1.5 text-gray-500 text-sm">
                                    Item Image:
                                  </p>
                                  <Box
                                    mt={2}
                                    display="flex"
                                    gap={2}
                                    flexWrap="wrap"
                                  >
                                    {((value as any) || []).map(
                                      (file: any, i: number) => {
                                        const imageSrc =
                                          typeof file === "string"
                                            ? file
                                            : file instanceof File
                                              ? URL.createObjectURL(file)
                                              : file?.product_image || "";
                                        // Create a unique key that includes file info to force re-render
                                        const uniqueKey = typeof file === "string" 
                                          ? `${file}-${i}` 
                                          : file instanceof File 
                                            ? `${file.name}-${file.size}-${file.lastModified}-${i}`
                                            : `${file?.product_image || 'unknown'}-${i}`;
                                        return (
                                          <Box
                                            key={uniqueKey}
                                            position="relative"
                                            className="cursor-pointer rounded-lg border-1 border-gray-300 hover:shadow-lg"
                                          >
                                            <img
                                              src={imageSrc}
                                              alt={`Uploaded ${i}`}
                                              onClick={() => {
                                                dispatch(
                                                  setCurrentPreviewImage(i)
                                                );
                                              }}
                                              style={{
                                                width: 60,
                                                height: 60,
                                                objectFit: "cover",
                                                borderRadius: "inherit",
                                              }}
                                            />
                                            {currentPreviewImage !== null && (
                                              <ImageViewer
                                                src={
                                                  (value as any)?.map(
                                                    (file: any) => {
                                                      if (
                                                        typeof file === "string"
                                                      ) {
                                                        return file;
                                                      }
                                                      if (file?.product_image) {
                                                        return file.product_image;
                                                      }
                                                      if (
                                                        file instanceof File
                                                      ) {
                                                        return URL.createObjectURL(
                                                          file
                                                        );
                                                      }
                                                      return "";
                                                    }
                                                  ) || []
                                                }
                                                currentIndex={
                                                  currentPreviewImage
                                                }
                                                disableScroll={false}
                                                closeOnClickOutside={true}
                                                onClose={() => {
                                                  dispatch(
                                                    setCurrentPreviewImage(null)
                                                  );
                                                }}
                                              />
                                            )}
                                          </Box>
                                        );
                                      }
                                    )}
                                  </Box>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      />
                    </div>

                    {/* Description Section - Second Column */}
                    <div
                      className="md:flex-1 md:mt-[10px] w-full"
                      style={{ marginTop: "-8px" }}
                    >
                      <Controller
                        name={`${itemPrefix}.description`}
                        control={control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              fullWidth
                              type="text"
                              label="Description"
                              multiline
                              disabled={isView}
                              minRows={5}
                              maxRows={10}
                              sx={{
                                ...inputStyle,
                                "& .MuiInputBase-root": {
                                  lineHeight: '21px',
                                },
                                "& .MuiInputBase-input": {
                                  resize: "vertical",
                                  lineHeight: '21px',
                                },
                              }}
                              error={
                                !!errors.lineItems?.[index]?.description ||
                                (field.value?.length || 0) >= 500
                              }
                              helperText={
                                <>
                                  {
                                    errors?.lineItems?.[index]?.description
                                      ?.message as string
                                  }
                                  {!errors?.lineItems?.[index]?.description && (
                                    <span
                                      className={`${(field.value?.length || 0) >= 500 ? "text-red-500" : "text-gray-500"}`}
                                    >
                                      {field.value?.length || 0}/500 characters
                                    </span>
                                  )}
                                </>
                              }
                              inputProps={{
                                maxLength: 500,
                              }}
                            />
                          );
                        }}
                      />
                    </div>
                    <div className="lg:hidden flex flex-col lg:items-center w-full lg:w-auto mt-1 md:mt-0">
                      <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        size="small"
                        id="image-ai-button"
                        onClick={async () => {
                          if (preAnalyzedData) {
                            setIsAIDialogOpen(true);
                            return;
                          }

                          setIsAnalyzing(true);
                          try {
                            if (!(images as any)?.length) {
                              toast.error("Please upload an image to analyze");
                              return;
                            }

                            // Get the first image and build FormData (image + modelNumber + description + selected item)
                            const image = (images as any)[0];
                            const formData = new FormData();
                            if (image instanceof File) {
                              formData.append('image', image);
                            } else if (typeof image === 'string') {
                              const response = await fetch(image);
                              const blob = await response.blob();
                              const file = new File([blob], 'image.jpg', { type: blob.type });
                              formData.append('image', file);
                            } else if (image?.product_image) {
                              // Update case: send image URL for server to fetch (avoids CORS from client-side fetch)
                              formData.append('image_url', image.product_image);
                            }
                            if (model != null) formData.append('modelNumber', model as string);
                            if (description != null) formData.append('description', description as string);
                            // Send only the selected line item, not the whole array
                            const itemToSend = selectedItem || 'Other';
                            formData.append('items[]', itemToSend);

                            // analyzeImage API handles image upload + analysis, returns analysis result
                            const uploadResponse = await analyzeImage(formData).unwrap();
                            const analysis =
                              uploadResponse?.data?.analysis ||
                              uploadResponse?.analysis ||
                              uploadResponse;

                            if (analysis?.choices?.[0]?.message?.content) {
                              setPreAnalyzedData(analysis);
                              setIsAIDialogOpen(true);
                            } else {
                              toast.error(
                                uploadResponse?.error || "Failed to analyze"
                              );
                            }
                          } catch (error) {
                            console.error("Error in AI analysis:", error);
                            toast.error("Failed to analyze");
                          } finally {
                            setIsAnalyzing(false);
                          }
                        }}
                        disabled={
                          !(images as any)?.length || isAnalyzing
                        }
                      >
                        {isAnalyzing ? (
                          <>
                            <CircularProgress size={16} sx={{ mr: 1 }} />
                            Analyzing...
                          </>
                        ) : (
                          "Analyze with AI"
                        )}
                      </Button>
                      <Typography
                        color="text.secondary"
                        className="mt-1 text-xs text-center"
                      >
                        {isAnalyzing
                            ? "Analyzing..."
                            : "Upload image to analyze"}
                      </Typography>
                    </div>
                  </div>
                </div>

                {/* Select Item Dropdown and Quantity - Only for child items */}
                {selectedArea && isChild && (
                  <div className="w-full col-span-6">
                    <div className="flex flex-col sm:flex-row gap-2">
                      <div className="w-full">
                        <Controller
                          name={`${itemPrefix}.name`}
                          control={control}
                          render={({ field }) => (
                            <FormControl
                              fullWidth
                              size="small"
                              sx={{ opacity: !selectedArea ? "0.5" : "1" }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <InputLabel id={`item-select-${index}`}>
                                Select Item *
                              </InputLabel>
                              <Select
                                labelId={`item-select-${index}`}
                                label="Select Item *"
                                value={field.value || ""}
                                onChange={field.onChange}
                                error={!!errors.lineItems?.[index]?.name}
                                disabled={isView || !selectedArea}
                                sx={selectStyle}
                              >
                                <MenuItem value="" disabled>
                                  Select Item *
                                </MenuItem>

                                {areas?.data
                                  ?.find((item) => item.name === selectedArea)
                                  ?.line_items?.filter(
                                    (item) => item.name !== "Other"
                                  )
                                  ?.map((item) => (
                                    <MenuItem key={item.id} value={item.name}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                <MenuItem value="Other">Other</MenuItem>
                              </Select>
                              {errors.lineItems?.[index]?.name && (
                                <FormHelperText error>
                                  {
                                    errors.lineItems[index].name
                                      .message as string
                                  }
                                </FormHelperText>
                              )}
                            </FormControl>
                          )}
                        />
                      </div>
                      {/* Other Item Field - Show in same row when "Other" is selected */}
                      {(selectedItem as string) === "Other" && (
                        <div className={`w-full`}>
                          <Controller
                            name={`${itemPrefix}.other_line_item_name`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                size="small"
                                type="text"
                                required
                                label="Other Item"
                                disabled={isView}
                                error={
                                  !!errors.lineItems?.[index]
                                    ?.other_line_item_name
                                }
                                helperText={
                                  errors?.lineItems?.[index]
                                    ?.other_line_item_name?.message as string
                                }
                                sx={inputStyle}
                                onClick={(e) => e.stopPropagation()}
                              />
                            )}
                          />
                        </div>
                      )}
                      {/* Quantity Field */}
                      <div className="w-full">
                        <Controller
                          name={`${itemPrefix}.quantity`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              size="small"
                              type="number"
                              label="Quantity"
                              disabled={isView}
                              inputProps={{ min: 1 }}
                              error={!!errors.lineItems?.[index]?.quantity}
                              helperText={
                                errors?.lineItems?.[index]?.quantity
                                  ?.message as string
                              }
                              sx={inputStyle}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  field.onChange("");
                                  return;
                                }
                                const numValue = parseInt(value, 10);
                                if (!isNaN(numValue) && numValue > 0) {
                                  field.onChange(numValue);
                                }
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="w-full col-span-6 md:col-span-2 lg:col-span-2 model">
                  <Controller
                    name={`${itemPrefix}.model`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="text"
                        label="Model No"
                        disabled={isView}
                        error={!!errors.lineItems?.[index]?.model}
                        helperText={
                          errors?.lineItems?.[index]?.model?.message as string
                        }
                        sx={inputStyle}
                      />
                    )}
                  />
                </div>

                <div className="w-full col-span-6 md:col-span-2 lg:col-span-2 purchase-cost">
                  <Controller
                    name={`${itemPrefix}.purchased_cost`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="number"
                        disabled={isView}
                        inputProps={{ min: 0 }}
                        label="Purchase Cost"
                        error={!!errors.lineItems?.[index]?.purchased_cost}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        helperText={
                          errors?.lineItems?.[index]?.purchased_cost
                            ?.message as string
                        }
                        sx={inputStyle}
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          if (rawValue === "") {
                            field.onChange("");
                            return;
                          }

                          // Only allow positive numbers (no negative, no decimal)
                          if (/^\d+$/.test(rawValue)) {
                            const numValue = parseInt(rawValue, 10);
                            // Double check it's not negative (shouldn't happen with regex but just in case)
                            if (numValue >= 0) {
                              field.onChange(numValue);
                            }
                          }
                        }}
                      />
                    )}
                  />
                </div>

                <div className="w-full col-span-6 md:col-span-2 lg:col-span-2 current-cost">
                  <Controller
                    name={`${itemPrefix}.current_cost`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="number"
                        disabled={isView}
                        inputProps={{ min: 0 }}
                        label="Estimated Current Value"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        error={!!errors.lineItems?.[index]?.current_cost}
                        helperText={
                          errors?.lineItems?.[index]?.current_cost
                            ?.message as string
                        }
                        sx={inputStyle}
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          if (rawValue === "") {
                            field.onChange("");
                            return;
                          }

                          // Only allow positive numbers (no negative, no decimal)
                          if (/^\d+$/.test(rawValue)) {
                            const numValue = parseInt(rawValue, 10);
                            // Double check it's not negative (shouldn't happen with regex but just in case)
                            if (numValue >= 0) {
                              field.onChange(numValue);
                            }
                          }
                        }}
                      />
                    )}
                  />
                </div>

                <div className="w-full col-span-6 md:col-span-3 lg:col-span-3 condition">
                  <Controller
                    name={`${itemPrefix}.condition`}
                    control={control}
                    render={({ field }) => (
                      <>
                        <FormControl sx={{ width: "100%" }}>
                          <InputLabel id={`condition-select-${index}`}>
                            Select Condition
                          </InputLabel>
                          <Select
                            fullWidth
                            sx={selectStyle}
                            labelId={`condition-select-${index}`}
                            label="Select Condition"
                            value={field.value || ""}
                            onChange={(event) =>
                              field.onChange(event.target.value)
                            }
                            error={!!errors.lineItems?.[index]?.condition}
                            disabled={isView}
                          >
                            <MenuItem
                              value=""
                              disabled
                              sx={{
                                color: errors.lineItems?.[index]?.condition
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              Select Condition
                            </MenuItem>
                            <MenuItem key="Old" value="Old">
                              Old
                            </MenuItem>
                            <MenuItem key="New" value="New">
                              Brand New
                            </MenuItem>
                          </Select>
                          {errors.lineItems?.[index]?.condition && (
                            <FormHelperText error>
                              {
                                errors.lineItems[index].condition
                                  .message as string
                              }
                            </FormHelperText>
                          )}
                        </FormControl>
                      </>
                    )}
                  />
                </div>

                <div className="w-full col-span-6 md:col-span-3 lg:col-span-3 purchase-date">
                  <Controller
                    name={`${itemPrefix}.purchased_date`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="date"
                        disabled={isView}
                        label="Purchase Date"
                        error={!!errors.lineItems?.[index]?.purchased_date}
                        helperText={
                          errors?.lineItems?.[index]?.purchased_date
                            ?.message as string
                        }
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: "1970-01-01",
                          max: TODAY_DATE,
                        }}
                        InputProps={{
                          endAdornment:
                            !isView && field.value ? (
                              <InputAdornment position="end" className="ml-0 -mr-2">
                                <IconButton
                                  size="small"
                                  onClick={() => field.onChange("")}
                                  onMouseDown={(e) => e.preventDefault()}
                                  edge="end"
                                  aria-label="Clear purchase date"
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ) : null,
                        }}
                        sx={inputStyle}
                      />
                    )}
                  />
                </div>
              </>
            )}
          </div>

          {/* Child Items Section */}
          {childItems && childItems.length > 0 && (
            <div className="-mt-3">
              <div className="space-y-4">
                {childItems.map(
                  ({ item: childItem, index: childIndex }, childMapIndex) => (
                    <div
                      key={childIndex}
                      className="md:ml-4 border-l-2 border-blue-200 pl-2 md:pl-4"
                    >
                      <LineItem
                        index={childIndex}
                        displayIndex={childIndex + 1}
                        control={control as any}
                        errors={errors as any}
                        watch={watch as any}
                        onRemove={() => {
                          // childIndex is the actual index in the main lineItems array
                          const originalItem = applicationData?.details?.find(
                            (item: any) =>
                              item?.line_item?.name === childItem?.name &&
                              item?.item_area?.name === childItem?.area
                          );
                          // Show confirmation dialog instead of directly removing
                          setPendingRemove?.({
                            index: childIndex,
                            itemId: originalItem?.id,
                            isParent: false,
                            areaName: childItem?.area,
                          });
                          setIsRemoveDialogOpen?.(true);
                        }}
                        setValue={setValue as any}
                        areas={areas}
                        isRemovable={
                          isChildRemovable ? isChildRemovable(childIndex) : true
                        }
                        isView={isView}
                        applicationId={applicationId}
                        expanded={!!expandedPanel?.[childIndex]}
                        onChange={() =>
                          setExpandedPanel?.((prev) => {
                            // Close only other child items, keep parent areas open
                            const newState: Record<number, boolean> = {
                              ...prev,
                            };

                            // Close all child accordions except the current one
                            Object.keys(newState).forEach((key) => {
                              const itemIndex = parseInt(key);
                              const currentItems = watch("lineItems") || [];
                              const item = currentItems[itemIndex];
                              if (
                                item &&
                                typeof item.parentIndex === "number"
                              ) {
                                newState[itemIndex] = false;
                              }
                            });

                            // Toggle current child accordion
                            newState[childIndex] = !prev[childIndex];
                            return newState;
                          })
                        }
                        isLastChild={childMapIndex === childItems.length - 1}
                        parentItemIndex={index}
                        trigger={trigger}
                        setExpandedPanel={setExpandedPanel}
                        removeLineItem={removeLineItem}
                        setIsRemoveDialogOpen={setIsRemoveDialogOpen}
                        setPendingRemove={setPendingRemove}
                      />
                    </div>
                  )
                )}
              </div>
            </div>
          )}
        </AccordionDetails>
      )}

      <ImageAIDialog
        open={isAIDialogOpen}
        onClose={() => {
          setIsAIDialogOpen(false);
          setPreAnalyzedData(null);
        }}
        images={(images as any) || []}
        modelNumber={model as string}
        description={description as string}
        items={areas?.data?.find((area) => area.name === selectedArea)?.line_items?.map((item) => item.name) || ["Other"]}
        selectedItem={selectedItem as string}
        onUseAIInfo={(newDescription, newCost, matchedItem) => {
          setValue(`${itemPrefix}.description`, newDescription);
          setValue(`${itemPrefix}.current_cost`, newCost);
          setValue(`${itemPrefix}.name`, matchedItem);
        }}
        preAnalyzedData={preAnalyzedData}
      />

      {/* Area Change Confirmation Dialog */}
      <Dialog
        open={isAreaChangeDialogOpen}
        onClose={handleAreaChangeCancel}
        aria-labelledby="area-change-dialog-title"
      >
        <DialogTitle id="area-change-dialog-title">Change Area</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the area from "
            {pendingAreaChange?.currentArea}" to "{pendingAreaChange?.newArea}"?
            All data related to the current area will be cleared and a new item
            will be added for the selected area.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAreaChangeCancel} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleAreaChangeConfirm}
            color="error"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

 
    </Accordion>
  );
}

function AddApplication({
  lineItems,
  setLineItems,
  isView,
  deletedId,
  setDeletedId,
  addressId,
  selectedAddress,
  onRequestChangeAddress,
}: AddApplicationProps) {
  const isMobile = useThemeMediaQuery((_theme) =>
    _theme.breakpoints.down("lg")
  );
  const methods = useFormContext();
  const {
    control,
    formState,
    watch,
    setValue,
    handleSubmit,
    reset,
    getValues,
    trigger,
  } = methods;
  const { errors } = formState;
  const { data: areas } = useGetAreasQuery({});
  const { data: addressesResponse } = useGetAddressesListQuery({});
  const addresses = addressesResponse?.data || [];
  const routeParams = useParams<{ applicationId: string }>();
  const { applicationId } = routeParams;
  const [expandedPanel, setExpandedPanel] = useState<Record<number, boolean>>({
    0: true,
  });
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  const [pendingRemove, setPendingRemove] = useState<{
    index: number;
    itemId?: number;
    isParent: boolean;
    areaName?: string;
  } | null>(null);

  const applicationQuery = useGetApplicationDetailQuery(applicationId, {
    skip: !applicationId || applicationId === "new",
  });
  const applicationData = applicationQuery.data?.data;
  const currentSelectedAddressId =
    selectedAddress?.id || applicationData?.address?.id || null;

  const selectableAddressesCount = useMemo(() => {
    return addresses.filter(
      (address: any) =>
        address?.application === null &&
        address?.is_enabled !== 0
    ).length;
  }, [addresses]);

  const canChangeSelectedAddress =
    !isView &&
    Boolean(onRequestChangeAddress) &&
    selectableAddressesCount > 1 &&
    Boolean(currentSelectedAddressId);
  const applicationDataLoading = applicationQuery.isLoading;
  const isError = applicationQuery.isError;

  // Function to find the first item with validation errors
  const findFirstErrorItem = (errors: any) => {
    if (!errors.lineItems || !Array.isArray(errors.lineItems)) {
      return -1;
    }

    // Find the first item that has any validation errors
    for (let i = 0; i < errors.lineItems.length; i++) {
      const item = errors.lineItems[i];
      if (item && Object.keys(item).length > 0) {
        return i;
      }
    }
    return -1;
  };

  // Function to open the accordion for a specific item
  const openErrorItem = (index: number) => {
    setExpandedPanel((prev) => {
      const newState: Record<number, boolean> = { ...prev };

      // Close all accordions first
      Object.keys(newState).forEach((key) => {
        newState[parseInt(key)] = false;
      });

      // Get the current line items to check if this is a child item
      const currentItems = watch("lineItems") || [];
      const itemWithError = currentItems[index];

      // If this is a child item (has parentIndex), also open its parent
      if (itemWithError && typeof itemWithError.parentIndex === "number") {
        const parentIndex = itemWithError.parentIndex;
        newState[parentIndex] = true; // Open parent
        newState[index] = true; // Open child
      } else {
        // This is a parent item, just open it
        newState[index] = true;
      }

      return newState;
    });
  };

  // Listen for the custom event to open error items
  useEffect(() => {
    const handleOpenErrorItem = (event: CustomEvent) => {
      const { index } = event.detail;
      if (typeof index === "number" && index >= 0) {
        openErrorItem(index);
      }
    };

    window.addEventListener(
      "openErrorItem",
      handleOpenErrorItem as EventListener
    );

    return () => {
      window.removeEventListener(
        "openErrorItem",
        handleOpenErrorItem as EventListener
      );
    };
  }, []);

  // Get the current line items from the form
  const currentLineItems = watch("lineItems") || [];

  // Initialize with one area dropdown by default
  useEffect(() => {
    if (currentLineItems.length === 0) {
      addLineItem();
    }
  }, []);

  const addLineItem = async () => {
    // Check if the last area is selected before adding a new area
    if (currentLineItems.length > 0) {
      const lastItem = currentLineItems[currentLineItems.length - 1];

      // If the last item is a parent item (area) and no area is selected, show validation error
      if (typeof lastItem.parentIndex === "undefined" && !lastItem.area) {
        // Trigger validation for the last area item
        const lastIndex = currentLineItems.length - 1;
        const isValid = await trigger(`lineItems.${lastIndex}.area`);

        if (!isValid) {
          // Open the last area item to show the validation error
          setExpandedPanel((prev) => {
            const newState: Record<number, boolean> = { ...prev };
            // Close all other accordions
            Object.keys(newState).forEach((key) => {
              newState[parseInt(key)] = false;
            });
            // Open the last area item
            newState[lastIndex] = true;
            return newState;
          });
          return; // Don't add new area if validation fails
        }
      }
    }

    const newLineItem = {
      area: "",
      name: "",
      condition: "Old",
      model: "",
      purchased_date: "",
      purchased_cost: null,
      current_cost: null,
      description: "",
      images: [],
      area_image: undefined,
      quantity: 1,
      other_area: "",
      other_line_item_name: "",
      parentIndex: undefined, // This will be an area-only item
    };

    const newLineItems = [...currentLineItems, newLineItem];
    const newIndex = newLineItems.length - 1;

    setExpandedPanel((prev) => {
      const newState: Record<number, boolean> = { ...prev };

      // Close all parent accordions (items without parentIndex)
      Object.keys(newState).forEach((key) => {
        const itemIndex = parseInt(key);
        const currentItems = watch("lineItems") || [];
        const item = currentItems[itemIndex];
        if (item && typeof item.parentIndex === "undefined") {
          newState[itemIndex] = false;
        }
      });

      // Open the newly added area
      newState[newIndex] = true;
      return newState;
    });
    setLineItems(newLineItems);
    setValue("lineItems", newLineItems);
  };

  // Helper function to check if a parent item (area) should be removable
  const isParentRemovable = (parentIndex: number) => {
    const currentItems = watch("lineItems") || [];
    const parentItems = currentItems.filter(
      (item) => typeof item.parentIndex === "undefined"
    );

    // Don't show Remove if it's the only area
    if (parentItems.length <= 1) {
      return false;
    }

    return true;
  };

  // Helper function to check if a child item should be removable
  const isChildRemovable = (childIndex: number) => {
    const currentItems = watch("lineItems") || [];
    const childItem = currentItems[childIndex];

    if (!childItem || typeof childItem.parentIndex !== "number") {
      return false;
    }

    const parentIndex = childItem.parentIndex;
    const parent = currentItems[parentIndex];

    if (!parent || !parent.area) {
      return false;
    }

    // Count how many child items belong to this parent's area
    const childItemsInSameArea = currentItems.filter(
      (item) =>
        typeof item.parentIndex === "number" && item.parentIndex === parentIndex
    );

    // Don't show Remove if it's the only child item in this area
    return childItemsInSameArea.length > 1;
  };

  const removeLineItem = (index: number, itemId?: number) => {
    if (currentLineItems.length <= 1) {
      toast.warning("At least one item is required");
      return;
    }

    const itemToRemove = currentLineItems[index];
    const newLineItems = [...currentLineItems];

    // If removing a parent item, also remove all its child items
    if (typeof itemToRemove.parentIndex === "undefined") {
      // This is a parent item - remove it and all its children from the same area
      const areaToRemove = itemToRemove.area;
      const itemsToRemove = [];

      // Find all items (parent and children) that belong to this area
      currentLineItems.forEach((item, idx) => {
        if (item.area === areaToRemove) {
          itemsToRemove.push(idx);
        }
      });

      // Remove items in reverse order to maintain correct indices
      itemsToRemove
        .sort((a, b) => b - a)
        .forEach((idx) => {
          newLineItems.splice(idx, 1);
        });

      // Update parentIndex for remaining items after removal
      newLineItems.forEach((item, idx) => {
        if (typeof item.parentIndex === "number") {
          // Count how many items were removed before this item's parent
          let removedBeforeParent = 0;
          itemsToRemove.forEach((removedIdx) => {
            if (removedIdx < item.parentIndex) {
              removedBeforeParent++;
            }
          });
          item.parentIndex = item.parentIndex - removedBeforeParent;
        }
      });
    } else {
      // This is a child item - just remove it
      newLineItems.splice(index, 1);

      // Update parentIndex for remaining items after removal
      newLineItems.forEach((item, idx) => {
        if (typeof item.parentIndex === "number" && item.parentIndex > index) {
          // Decrease parentIndex for items that had a parent with higher index
          item.parentIndex = item.parentIndex - 1;
        }
      });
    }

    setLineItems(newLineItems);
    setValue("lineItems", newLineItems);

    // Add to deleted IDs if it's an existing item
    if (itemId) {
      setDeletedId([...deletedId, itemId]);
    }
  };

  const handleRemoveConfirm = () => {
    if (pendingRemove) {
      removeLineItem(pendingRemove.index, pendingRemove.itemId);
      setIsRemoveDialogOpen(false);
      setPendingRemove(null);
    }
  };

  const handleRemoveCancel = () => {
    setIsRemoveDialogOpen(false);
    setPendingRemove(null);
  };

  const onSubmit = (data: { lineItems: LineItemFormData[] }) => {
    const formData = new FormData();

    data.lineItems.forEach((item, index) => {
      const prefix = `line_item[${index}]`;

      // Append all fields except image
      Object.entries(item).forEach(([key, value]) => {
        if (key !== "images" && value !== undefined && value !== null) {
          formData.append(`${prefix}[${key}]`, String(value));
        }
      });

      // Handle images separately
      if (item.images) {
        item.images.forEach((image, i) => {
          if (image instanceof File) {
            formData.append(`${prefix}[images][${i}]`, image);
          } else if (typeof image === "string") {
            formData.append(`${prefix}[images][${i}]`, image);
          }
        });
      }
    });
  };

  useEffect(() => {
    if (applicationData) {
      // Group items by area
      const itemsByArea: Record<string, any[]> = {};
      applicationData?.details?.forEach((item: any) => {
        const areaName = item?.item_area?.name || item?.area || "Unassigned";
        if (!itemsByArea[areaName]) {
          itemsByArea[areaName] = [];
        }
        itemsByArea[areaName].push({
          ...item,
          isOtherTrue: !item?.item_area?.name,
        });
      });

      const items: LineItemFormData[] = [];
      let currentIndex = 0;

      Object.entries(itemsByArea).forEach(([areaName, areaItems]) => {
        // Create parent item (area-only) for each area
        const parentIndex = currentIndex;
        const isOtherArea = areaItems.some((item: any) => item.isOtherTrue);
        
        // Get area_image from the first item in the area (all items in same area share same area_image)
        const firstItemAreaImage = areaItems[0]?.product_area_image;

        items.push({
          area: isOtherArea
            ? "Other"
            : areaName === "Unassigned"
              ? ""
              : areaName,
          name: "",
          condition: "Old",
          model: "",
          purchased_date: "",
          purchased_cost: null,
          current_cost: null,
          description: "",
          images: [],
          area_image: firstItemAreaImage 
            ? (typeof firstItemAreaImage === 'string' 
                ? { product_image: firstItemAreaImage }
                : firstItemAreaImage)
            : undefined,
          quantity: 1,
          other_area: isOtherArea ? areaName : "",
          other_line_item_name: "",
          parentIndex: undefined, // Parent items have no parentIndex
        });
        currentIndex++;
        // Create child items for each item in the area
        areaItems.forEach((item: any) => {
          items.push({
            area: isOtherArea ? "Other" : areaName || "",
            name:
              item?.line_item && item?.line_item?.name
                ? item?.line_item?.name
                : item?.item_name
                  ? "Other"
                  : "",
            condition: item?.condition || "Old",
            model: item?.model || "",
            purchased_date: item?.purchased_date || "",
            purchased_cost: item?.purchased_cost || null,
            current_cost: item?.current_cost || null,
            description: item?.description || "",
            images:
              item?.images?.map((img: any) => ({
                product_image: img.product_image,
              })) || [],
            area_image: undefined, // area_image is now on parent item, not child items
            quantity: item?.quantity || 1,
            other_area: "",
            other_line_item_name: item?.item_name || "",
            parentIndex: parentIndex, // Child items point to their parent
          });
          currentIndex++;
        });
      });
      // If no items exist, create a default area-only item
      if (items.length === 0) {
        items.push({
          area: "",
          name: "",
          condition: "Old",
          model: "",
          purchased_date: "",
          purchased_cost: null,
          current_cost: null,
          description: "",
          images: [],
          area_image: undefined,
          quantity: 1,
          other_area: "",
          other_line_item_name: "",
          parentIndex: undefined,
        });
      }

      reset({ lineItems: items });
      setLineItems(items);
    }
  }, [applicationData]);

  if (applicationDataLoading) {
    return <FuseLoading />;
  }

  if (isError && applicationId !== "new") {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        className="flex flex-col flex-1 items-center justify-center h-full"
      >
        <Typography color="text.secondary" variant="h5">
          There is no such asset!
        </Typography>
        <Button
          className="mt-6"
          component={Link}
          variant="outlined"
          href="/apps/applications"
          color="inherit"
        >
          Go to Assets Page
        </Button>
      </motion.div>
    );
  }

  return (
    <>
      <FusePageCarded
        header={
          <AddApplicationHeader
            lineItems={{} as any}
            areas={areas}
            onSubmit={handleSubmit(onSubmit)}
            applicationData={applicationData}
            deletedId={deletedId?.map(String)}
            addressId={addressId}
          />
        }
        content={
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`p-4 sm:p-6 space-y-${isView ? "4" : "6"}`}>
              {!isView && (selectedAddress || applicationData?.address) && (
                <Box className="mb-4 p-4 border border-divider rounded-lg bg-gray-50">
                  <Box className="flex items-start justify-between gap-2">
                  <Typography
                    variant="caption"
                    className="text-gray-600 font-medium uppercase mb-2 block underline"
                  >
                    Selected Address:
                  </Typography>
                    {canChangeSelectedAddress && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={onRequestChangeAddress}
                      >
                        Change
                      </Button>
                    )}
                  </Box>
                  <Typography
                    variant="h6"
                    className="font-semibold mb-1"
                  >
                    {selectedAddress?.name || applicationData?.address?.name || 'N/A'}
                  </Typography>
                  <Typography
                    variant="body2"
                    className="text-gray-700"
                  >
                    {selectedAddress?.location_name || applicationData?.address?.location_name || 'N/A'}
                  </Typography>
                </Box>
              )}
              <div className="w-full">
                {!isView &&
                  ["under_verification", "rejected", ""].includes(
                    applicationData?.application_status || ""
                  ) && (
                    <Typography color="text.secondary" className="mb-4">
                      You can add multiple items in an asset.
                    </Typography>
                  )}
              </div>
              {isView && (
                <div className="flex items-start px-7 py-5 mb-3 border border-divider rounded-lg">
                  <div className="flex flex-col gap-4 w-full">
                    <Typography className="text-xl font-semibold mb-2">
                      Asset Information:
                    </Typography>
                    <div className="flex flex-col gap-5 md:gap-0 md:flex-row md:items-center w-full">
                      <div className="flex items-center gap-2 w-[30%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Asset Number:
                        </p>
                        <p>{applicationData?.application_number}</p>
                      </div>
                      <div className="flex items-center gap-2 w-[40%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Asset Status:
                        </p>
                        <p>
                          {applicationData?.application_status ? (
                            <ApplicationsStatus
                              name={applicationData?.application_status}
                            />
                          ) : (
                            "-"
                          )}
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-semibold md:w-[160px] whitespace-nowrap">
                          Applied Date:
                        </p>
                        <p>{applicationData?.apply_date_formatted || "-"}</p>
                      </div>
                    </div> 
                    <div className="flex md:items-center flex-col gap-5 md:gap-0 md:flex-row w-full">
                      <div className="flex items-center gap-2 w-[30%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Total Items:
                        </p>
                        <p>{applicationData?.total_items}</p>
                      </div>
                      <div className="flex items-center gap-2 w-[40%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Total purchased cost:
                        </p>
                        <p>${applicationData?.sum_purchased_cost}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-semibold w-[185px] whitespace-nowrap">
                          Total estimated current cost:
                        </p>
                        <p>${applicationData?.sum_current_cost}</p>
                      </div>
                    </div>
                    <Divider className="my-4" />
                    <Typography className="text-xl font-semibold mb-2">
                      Address Information:
                    </Typography>
                    <div className="flex md:items-center flex-col gap-5 md:gap-0 md:flex-row w-full">
                      <div className="flex items-center gap-2 w-[30%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Address Name:
                        </p>
                        <p>{applicationData?.address?.name ||
                            "-"}</p>
                      </div>
                      <div className="flex items-center gap-2 w-[40%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Address Type:
                        </p>
                        <p>{applicationData?.address?.type ||
                            "-"}</p>
                      </div>
                      <div className="flex items-center gap-2 w-[30%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Attached Documents:{" "}
                        </p>
                        <p>{applicationData?.address?.documents?.length ||
                            "-"}</p>
                      </div>
                    </div>
                    <div className="flex flex-wrap md:items-center flex-col gap-5 md:gap-0 md:flex-row w-full">
                      <div className="flex items-center gap-2 w-[100%]">
                        <p className="font-semibold w-[160px] whitespace-nowrap">
                          Address Location:
                        </p>
                        <p>{applicationData?.address?.location_name ||
                            "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {(() => {
                // Get all selected areas from current form data
                const getSelectedAreas = () => {
                  const selected = new Set<string>();
                  currentLineItems.forEach((item) => {
                    if (item.area && item.area !== "Other") {
                      selected.add(item.area);
                    }
                  });
                  return selected;
                };

                const selectedAreas = getSelectedAreas();

                // Group items by parent-child relationship
                const parentItems: {
                  item: LineItemFormData;
                  index: number;
                  children: { item: LineItemFormData; index: number }[];
                }[] = [];
                const processedIndices = new Set<number>();
                currentLineItems.forEach((item, index) => {
                  if (processedIndices.has(index)) return;

                  if (typeof item.parentIndex === "number") {
                    // This is a child item, find its parent
                    const parentIndex = item.parentIndex;
                    const parentItem = currentLineItems[parentIndex];

                    if (parentItem) {
                      // Find or create parent group
                      let parentGroup = parentItems.find(
                        (p) => p.index === parentIndex
                      );
                      if (!parentGroup) {
                        parentGroup = {
                          item: parentItem,
                          index: parentIndex,
                          children: [],
                        };
                        parentItems.push(parentGroup);
                        processedIndices.add(parentIndex);
                      }
                      parentGroup.children.push({ item, index });
                      processedIndices.add(index);
                    }
                  } else {
                    // This is a parent item
                    if (!processedIndices.has(index)) {
                      parentItems.push({ item, index, children: [] });
                      processedIndices.add(index);
                    }
                  }
                });
                // Render parent items and their children
                return parentItems.map(({ item, index, children }) => (
                  <LineItem
                    key={index}
                    index={index}
                    displayIndex={index + 1}
                    control={control as any}
                    errors={errors as any}
                    watch={watch as any}
                    onRemove={(idx) => {
                      // For parent items, we don't need to pass an ID since they're not in the original data
                      // Show confirmation dialog instead of directly removing
                      const itemToRemove = currentLineItems[idx];
                      setPendingRemove({
                        index: idx,
                        itemId: undefined,
                        isParent: true,
                        areaName: itemToRemove?.area,
                      });
                      setIsRemoveDialogOpen(true);
                    }}
                    setValue={setValue as any}
                    areas={areas}
                    isRemovable={isParentRemovable(index)}
                    isChildRemovable={isChildRemovable}
                    isView={
                      isView ||
                      !["under_verification", "rejected", ""].includes(
                        applicationData?.application_status || ""
                      )
                    }
                    applicationId={applicationId}
                    expanded={!!expandedPanel[index]}
                    onChange={() =>
                      setExpandedPanel((prev) => {
                        // Close only other parent areas, keep child items open
                        const newState: Record<number, boolean> = { ...prev };

                        // Close all parent accordions except the current one
                        Object.keys(newState).forEach((key) => {
                          const itemIndex = parseInt(key);
                          const currentItems = watch("lineItems") || [];
                          const item = currentItems[itemIndex];
                          if (item && typeof item.parentIndex === "undefined") {
                            newState[itemIndex] = false;
                          }
                        });

                        // Toggle current parent accordion
                        newState[index] = !prev[index];
                        return newState;
                      })
                    }
                    childItems={children}
                    expandedPanel={expandedPanel}
                    setExpandedPanel={setExpandedPanel}
                    removeLineItem={removeLineItem}
                    applicationData={applicationData}
                    selectedAreas={selectedAreas}
                    trigger={trigger}
                    setIsRemoveDialogOpen={setIsRemoveDialogOpen}
                    setPendingRemove={setPendingRemove}
                  />
                ));
              })()}
              {!isView && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={addLineItem}
                  startIcon={<AddIcon />}
                >
                  Add Area
                </Button>
              )}
            </div>
          </form>
        }
        scroll={isMobile ? "normal" : "content"}
      />

      {/* Remove Confirmation Dialog for Parent Items */}
      <Dialog
        open={isRemoveDialogOpen}
        onClose={handleRemoveCancel}
        aria-labelledby="remove-dialog-title"
      >
        <DialogTitle id="remove-dialog-title">
          {pendingRemove?.isParent ? "Remove Area" : "Remove Item"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {pendingRemove?.isParent ? (
              <>
                Are you sure you want to remove the "{pendingRemove?.areaName}"
                area?
                <br />
                <strong>This will also remove all items in this area.</strong>
              </>
            ) : (
              <>
                Are you sure you want to remove this item?
                <br />
                <strong>This action cannot be undone.</strong>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveCancel} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleRemoveConfirm}
            color="error"
            variant="contained"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AddApplication;
